// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__CdnVb","subtitle":"success_subtitle__sik6G","opacity-transition":"success_opacity-transition__IR911"};